// extracted by mini-css-extract-plugin
export default {"zoomModal":"g2-z","image":"h2-z","button":"i2-z","isOverlayShown":"j2-z"};